import actions from '@/core/store/item-ata/actions'
import mutations from '@/core/store/item-ata/mutations'
import state from '@/core/store/item-ata/state'
import getters from '@/core/store/item-ata/getters'
import realinhamento from '@/core/store/item-ata/realinhamento'
import aditamento from '@/core/store/item-ata/aditamento'
import bloqueio from '@/core/store/item-ata/bloqueio'
import alterarFornecedor from '@/core/store/item-ata/alterar-fornecedor'
import alterarClassificacao from '@/core/store/item-ata/alterar-classificacao'
import transferencia from '@/core/store/item-ata/transferencia'

export default {
	actions,
	mutations,
	state,
	getters,
	modules: {
		realinhamento,
		aditamento,
		alterarFornecedor,
		bloqueio,
		alterarClassificacao,
		transferencia,
	},
}
